import dayjs from "dayjs";

const MAX_DAYS = 7;

export function getInterval() {
  const date = dayjs();

  const today = date.day();

  let days = MAX_DAYS;

  if (today === 0) {
    days = days + 1;
  } else {
    days = days + 2;
  }

  return [
    date.format("YYYY-MM-DD"),
    date.add(days, "day").format("YYYY-MM-DD"),
  ];
}
